"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lightVariables = exports.light = exports.darkVariables = exports.dark = void 0;
require("./spectrum.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const darkVariables = {
  '--blue0': '0,16,51',
  '--blue5': '1,29,91',
  '--blue10': '1,42,130',
  '--blue15': '3,51,154',
  '--blue20': '5,59,177',
  '--blue30': '10,72,206',
  '--blue40': '19,84,225',
  '--blue50': '33,98,238',
  '--blue60': '55,115,245',
  '--blue70': '87,139,250',
  '--blue80': '132,170,253',
  '--blue90': '185,207,255',
  '--blue100': '245,248,255',
  '--green0': '0,51,30',
  '--green5': '0,61,36',
  '--green10': '1,71,42',
  '--green15': '2,82,48',
  '--green20': '2,92,55',
  '--green30': '6,112,68',
  '--green40': '11,133,82',
  '--green50': '21,153,98',
  '--green60': '39,173,117',
  '--green70': '68,194,141',
  '--green80': '111,214,171',
  '--green90': '171,235,208',
  '--green100': '245,255,251',
  '--orange0': '51,13,0',
  '--orange5': '79,20,0',
  '--orange10': '107,28,1',
  '--orange15': '131,36,2',
  '--orange20': '155,44,4',
  '--orange30': '189,59,9',
  '--orange40': '213,76,18',
  '--orange50': '230,96,32',
  '--orange60': '240,120,54',
  '--orange70': '248,150,86',
  '--orange80': '252,185,131',
  '--orange90': '254,219,185',
  '--orange100': '255,250,245',
  '--gray0': '10,11,13',
  '--gray5': '20,21,25',
  '--gray10': '30,32,37',
  '--gray15': '40,43,49',
  '--gray20': '50,53,61',
  '--gray30': '70,75,85',
  '--gray40': '91,97,110',
  '--gray50': '114,120,134',
  '--gray60': '138,145,158',
  '--gray70': '165,170,182',
  '--gray80': '193,198,207',
  '--gray90': '224,226,231',
  '--gray100': '255,255,255',
  '--indigo0': '8,15,51',
  '--indigo5': '14,27,91',
  '--indigo10': '21,39,130',
  '--indigo15': '27,47,154',
  '--indigo20': '33,56,177',
  '--indigo30': '48,73,206',
  '--indigo40': '68,92,225',
  '--indigo50': '92,113,238',
  '--indigo60': '121,138,245',
  '--indigo70': '153,165,250',
  '--indigo80': '187,194,253',
  '--indigo90': '219,223,255',
  '--indigo100': '246,247,255',
  '--pink0': '51,10,44',
  '--pink5': '70,14,61',
  '--pink10': '89,19,78',
  '--pink15': '108,24,94',
  '--pink20': '126,30,111',
  '--pink30': '159,44,142',
  '--pink40': '187,64,170',
  '--pink50': '208,88,193',
  '--pink60': '225,117,214',
  '--pink70': '237,149,230',
  '--pink80': '246,184,243',
  '--pink90': '252,217,251',
  '--pink100': '255,245,255',
  '--purple0': '25,13,51',
  '--purple5': '46,23,91',
  '--purple10': '66,34,130',
  '--purple15': '80,42,154',
  '--purple20': '93,50,177',
  '--purple30': '116,67,206',
  '--purple40': '137,86,225',
  '--purple50': '157,109,238',
  '--purple60': '179,136,245',
  '--purple70': '201,164,250',
  '--purple80': '221,195,253',
  '--purple90': '238,223,255',
  '--purple100': '251,247,255',
  '--red0': '51,0,4',
  '--red5': '79,0,7',
  '--red10': '107,1,10',
  '--red15': '131,4,14',
  '--red20': '155,7,19',
  '--red30': '189,19,33',
  '--red40': '213,38,52',
  '--red50': '230,64,78',
  '--red60': '240,97,109',
  '--red70': '248,134,144',
  '--red80': '252,174,181',
  '--red90': '254,213,216',
  '--red100': '255,245,246',
  '--teal0': '0,20,38',
  '--teal5': '0,32,59',
  '--teal10': '0,45,79',
  '--teal15': '0,58,99',
  '--teal20': '0,72,118',
  '--teal30': '0,99,153',
  '--teal40': '0,125,182',
  '--teal50': '0,149,205',
  '--teal60': '0,170,223',
  '--teal70': '6,190,236',
  '--teal80': '69,217,245',
  '--teal90': '149,239,251',
  '--teal100': '240,254,255',
  '--yellow0': '0,0,0',
  '--yellow5': '22,7,0',
  '--yellow10': '43,15,0',
  '--yellow15': '65,27,0',
  '--yellow20': '88,41,0',
  '--yellow30': '129,73,0',
  '--yellow40': '169,109,0',
  '--yellow50': '204,146,0',
  '--yellow60': '233,179,0',
  '--yellow70': '255,210,0',
  '--yellow80': '255,223,68',
  '--yellow90': '255,237,150',
  '--yellow100': '255,252,241'
};
exports.darkVariables = darkVariables;
const lightVariables = {
  '--blue0': '245,248,255',
  '--blue5': '211,225,255',
  '--blue10': '176,202,255',
  '--blue15': '146,182,255',
  '--blue20': '115,162,255',
  '--blue30': '70,132,255',
  '--blue40': '38,110,255',
  '--blue50': '16,94,255',
  '--blue60': '0,82,255',
  '--blue70': '0,75,235',
  '--blue80': '0,62,193',
  '--blue90': '0,41,130',
  '--blue100': '0,24,77',
  '--green0': '245,255,251',
  '--green5': '203,245,227',
  '--green10': '163,235,205',
  '--green15': '131,224,186',
  '--green20': '101,214,167',
  '--green30': '60,194,138',
  '--green40': '34,173,115',
  '--green50': '18,153,97',
  '--green60': '9,133,81',
  '--green70': '4,112,67',
  '--green80': '1,92,54',
  '--green90': '0,71,42',
  '--green100': '0,51,30',
  '--orange0': '255,250,245',
  '--orange5': '254,232,210',
  '--orange10': '253,213,176',
  '--orange15': '251,194,147',
  '--orange20': '249,174,118',
  '--orange30': '244,140,76',
  '--orange40': '237,112,47',
  '--orange50': '225,89,27',
  '--orange60': '207,71,14',
  '--orange70': '181,54,6',
  '--orange80': '145,39,2',
  '--orange90': '100,26,0',
  '--orange100': '51,13,0',
  '--gray0': '255,255,255',
  '--gray5': '238,240,243',
  '--gray10': '222,225,231',
  '--gray15': '206,210,219',
  '--gray20': '191,196,207',
  '--gray30': '163,169,182',
  '--gray40': '137,144,158',
  '--gray50': '113,120,134',
  '--gray60': '91,97,110',
  '--gray70': '70,75,85',
  '--gray80': '50,53,61',
  '--gray90': '30,32,37',
  '--gray100': '10,11,13',
  '--indigo0': '246,247,255',
  '--indigo5': '230,232,255',
  '--indigo10': '214,218,254',
  '--indigo15': '198,204,253',
  '--indigo20': '181,189,253',
  '--indigo30': '148,161,251',
  '--indigo40': '116,135,247',
  '--indigo50': '89,111,242',
  '--indigo60': '66,91,233',
  '--indigo70': '47,74,215',
  '--indigo80': '31,54,173',
  '--indigo90': '17,32,107',
  '--indigo100': '8,15,51',
  '--pink0': '255,245,255',
  '--pink5': '253,228,253',
  '--pink10': '251,212,250',
  '--pink15': '248,195,245',
  '--pink20': '244,178,240',
  '--pink30': '235,143,227',
  '--pink40': '221,110,209',
  '--pink50': '203,81,187',
  '--pink60': '179,58,162',
  '--pink70': '149,39,133',
  '--pink80': '116,26,102',
  '--pink90': '83,17,72',
  '--pink100': '51,10,44',
  '--purple0': '251,247,255',
  '--purple5': '244,233,255',
  '--purple10': '235,219,254',
  '--purple15': '227,204,253',
  '--purple20': '217,189,253',
  '--purple30': '197,160,251',
  '--purple40': '177,132,247',
  '--purple50': '157,107,242',
  '--purple60': '138,85,233',
  '--purple70': '119,67,215',
  '--purple80': '90,48,173',
  '--purple90': '54,27,107',
  '--purple100': '25,13,51',
  '--red0': '255,245,246',
  '--red5': '254,225,228',
  '--red10': '253,206,210',
  '--red15': '251,186,191',
  '--red20': '249,166,173',
  '--red30': '244,127,136',
  '--red40': '237,89,102',
  '--red50': '225,57,71',
  '--red60': '207,32,47',
  '--red70': '181,15,29',
  '--red80': '145,5,16',
  '--red90': '100,1,9',
  '--red100': '51,0,4',
  '--teal0': '240,254,255',
  '--teal5': '188,246,253',
  '--teal10': '136,237,251',
  '--teal15': '93,226,248',
  '--teal20': '51,213,244',
  '--teal30': '0,188,235',
  '--teal40': '0,169,221',
  '--teal50': '0,147,203',
  '--teal60': '0,123,179',
  '--teal70': '0,97,149',
  '--teal80': '0,71,116',
  '--teal90': '0,47,83',
  '--teal100': '0,27,51',
  '--yellow0': '255,252,241',
  '--yellow5': '255,242,178',
  '--yellow10': '255,233,114',
  '--yellow15': '255,221,57',
  '--yellow20': '255,210,0',
  '--yellow30': '239,189,0',
  '--yellow40': '216,162,0',
  '--yellow50': '188,131,0',
  '--yellow60': '154,96,0',
  '--yellow70': '115,62,0',
  '--yellow80': '74,33,0',
  '--yellow90': '34,12,0',
  '--yellow100': '0,0,0'
};
exports.lightVariables = lightVariables;
const dark = "cds-dark-d255ydu";
exports.dark = dark;
const light = "cds-light-l1k3tbpe";
exports.light = light;